import { defineMessages } from "@/lib/i18n/messages";
import type { EventCategory, EventStatus } from "./events";

// Las categorías son datos (vienen así del backend y arman las URLs
// /eventos/categoria/musica): se traducen SOLO al mostrarlas. Además de las 7
// que muestra el sitio público (EventCategory), están las categorías con que
// se guarda cada evento en el backend (Teatro, Danza...), que aparecen en los
// formularios y el dashboard.
export default defineMessages({
  es: {
    categories: {
      Música: "Música",
      Cultura: "Cultura",
      Gastronomía: "Gastronomía",
      Deportes: "Deportes",
      Familia: "Familia",
      Niños: "Niños",
      Ferias: "Ferias",
      Teatro: "Teatro",
      Danza: "Danza",
      Exposición: "Exposición",
      Cine: "Cine",
      Taller: "Taller",
      Feria: "Feria",
      Museos: "Museos",
      Literatura: "Literatura",
      Fotografía: "Fotografía",
      Otro: "Otro",
    } satisfies Record<EventCategory, string> & Record<string, string>,
    free: "Gratis",
    priceOnRequest: "Consultar",
    statuses: {
      draft: "Borrador",
      pending: "Pendiente",
      approved: "Aprobado",
      rejected: "Rechazado",
      canceled: "Cancelado",
    } satisfies Record<EventStatus, string>,
  },
  en: {
    categories: {
      Música: "Music",
      Cultura: "Culture",
      Gastronomía: "Food & drink",
      Deportes: "Sports",
      Familia: "Family",
      Niños: "Kids",
      Ferias: "Fairs",
      Teatro: "Theater",
      Danza: "Dance",
      Exposición: "Exhibition",
      Cine: "Film",
      Taller: "Workshop",
      Feria: "Fair",
      Museos: "Museums",
      Literatura: "Literature",
      Fotografía: "Photography",
      Otro: "Other",
    },
    free: "Free",
    priceOnRequest: "Price on request",
    statuses: {
      draft: "Draft",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      canceled: "Canceled",
    },
  },
});
